var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 46.1408C36.2281 46.1408 46.1409 36.2279 46.1409 23.9998C46.1409 11.7717 36.2281 1.85889 24 1.85889C11.7719 1.85889 1.85907 11.7717 1.85907 23.9998C1.85907 36.2279 11.7719 46.1408 24 46.1408Z",
    fill: "#3CC13B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C10.7675 48 0 37.2344 0 24C0 10.7675 10.7675 0 24 0C37.2344 0 48 10.7675 48 24C48 37.2344 37.2344 48 24 48ZM24 3.71803C12.8161 3.71803 3.71803 12.8161 3.71803 24C3.71803 35.1839 12.8161 44.282 24 44.282C35.1839 44.282 44.282 35.182 44.282 24C44.282 12.8161 35.1839 3.71803 24 3.71803Z",
    fill: "#3CC13B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1 32.8302C20.6018 32.8302 20.1258 32.6313 19.7744 32.2744L12.9147 25.303C12.1952 24.5706 12.2045 23.3957 12.937 22.6744C13.6694 21.9568 14.8462 21.9642 15.5656 22.6967L21.0461 28.2663L32.3843 15.7792C33.0777 15.0189 34.2526 14.965 35.0092 15.6529C35.7695 16.3426 35.8253 17.5175 35.1356 18.2797L22.4757 32.2222C22.1318 32.6015 21.6484 32.8208 21.1372 32.832C21.1242 32.8302 21.113 32.8302 21.1 32.8302Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessful);
export default __webpack_public_path__ + "static/media/successful.e5151819aafc4c047045ee37dda8e1f1.svg";
export { ForwardRef as ReactComponent };